(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('orderByStartWithFirst', orderByStartWithFirst);

    function orderByStartWithFirst() {
        return orderByStartWithFirstFilter;

        function orderByStartWithFirstFilter(array, property, q) {
        	var results = array;
    		results.sort(function(a,b) {
    			return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    		});
        	results = results
            .reduce(function(res, elem) {
            	if (elem && elem[property]) {
                    var idx = elem[property].toLowerCase().indexOf(q.toLowerCase());
                    if(idx === 0) {
                      res[0].push(elem)
                    } else if(idx > 0) {
                      res[1].push(elem)
                    }
            	}
            	return res;   
            },[[],[]]);
        	return results[0].concat(results[1]);
        }
    }
})();
